import { useState } from 'react';
import { usePermissions } from '../../../../hooks/usePermissions';
import useGetProviderContacts from '../../api/useGetProviderContacts';

type Props = {
  providerId: string;
};

export function useProviderContactsSidebar(props: Props) {
  const { isAdmin } = usePermissions();
  const { data: contacts = [], isLoading } = useGetProviderContacts(props.providerId);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  return {
    contacts,
    isLoading,
    isAdmin,
    count: contacts.length,
    isAddModalOpen,
    handleOpenAddModal: () => setIsAddModalOpen(true),
    handleCloseAddModal: () => setIsAddModalOpen(false),
  };
}

